<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <div class="flex justify-between">
      <p>
        This page provides a global overview of stock products across all REKOM
        countries, region and venues.
      </p>
      <div class="flex justify-end">
        <!-- <vs-button icon="add" @click="onClickCreateNew" type="relief" color="primary" class="mr-3"
          >Add new</vs-button
        >
        <vs-button
          v-if="hasPermission('pp.pim.stockproductrequests.show')"
          icon="list"
          @click="$router.push({ name: 'pp-stock-product-requests' })"
          type="relief"
          color="primary"
          >View requests</vs-button
        > -->
      </div>
    </div>

    <h5 class="mt-6 mb-5">
      Filter by location ({{ stockProductsFiltered.length }} products total)
    </h5>
    <vs-row vs-justify="flex-start" class="mt-4">
      <vs-button
        v-for="location in filterCountries"
        :key="location.id"
        :class="{
          'rounded-l-lg': location.id === filterCountries[0].id,
          'rounded-r-lg':
            location.id === filterCountries[filterCountries.length - 1].id,
        }"
        class="rounded-none w-48"
        :color="
          filterCountryId === location.id || filterCountryId === null
            ? 'primary'
            : 'grey'
        "
        @click="
          filterCountryId === location.id
            ? (filterCountryId = null)
            : (filterCountryId = location.id)
        "
        :icon="
          filterCountryId === location.id || filterCountryId === null
            ? 'check'
            : ''
        "
      >
        {{ location.name }}
      </vs-button>
    </vs-row>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-4"
        pagination
        search
        :max-items="50"
        :data="stockProductsFiltered"
      >
        <template slot="thead">
          <vs-th sort-key="number">Number</vs-th>
          <vs-th sort-key="country.code">Country</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="productCategory.name">Category</vs-th>
          <vs-th sort-key="vendor.name">Vendor</vs-th>
          <vs-th sort-key="unitPrice">Unit price</vs-th>
          <vs-th sort-key="caseSize">Case size</vs-th>
          <vs-th sort-key="inStockAmount"># in stock</vs-th>
          <vs-th sort-key="inStockValue">Stock value</vs-th>
          <vs-th sort-key="inactive">Status</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="ProductIcon" />
                  <p class="ml-4">{{ tr.number }}</p>
                </div>
              </vs-td>
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img
                    width="30"
                    :src="
                      require(`@/assets/images/flags/${tr.country.code}.png`)
                    "
                  />
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.name">
                  {{ tr.name }}
                </div>
                <div v-else>
                  <vs-chip> No name </vs-chip>
                </div>
              </vs-td>

              <vs-td>
                <div v-if="tr.productCategory">
                  <code>{{ tr.productCategory.name }}</code>
                </div>
                <div v-else>
                  <vs-chip>No category</vs-chip>
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.vendor">
                  <code>{{ tr.vendor.name }}</code>
                </div>
                <div v-else>
                  <vs-chip>No vendor</vs-chip>
                </div>
              </vs-td>
              <vs-td>
                {{ tr.unitPrice | numberFormatDK }}
                {{ tr.country.code | currencyFromCountryCode }}
              </vs-td>
              <vs-td>
                <vs-chip>{{ tr.caseSize }}</vs-chip>
              </vs-td>
              <vs-td>
                <vs-chip> {{ tr.inStockAmount }}</vs-chip>
              </vs-td>
              <vs-td>
                {{ tr.inStockValue | numberFormatDK }}
                {{ tr.country.code | currencyFromCountryCode }}
              </vs-td>
              <vs-td>
                <vs-chip :color="tr.locked ? 'danger' : ''">
                  {{ tr.locked ? "Locked" : "Unlocked" }}
                </vs-chip>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";

export default {
  components: {},
  data() {
    return {
      selected: [],
      filterCountryId: null,
      isLoading: true,
      ProductIcon,
      currentPage: 1,
      pageSize: 10,
      filterCountries: [
        {
          id: "dk",
          name: "Denmark",
        },
        {
          id: "no",
          name: "Norway",
        },
        {
          id: "fi",
          name: "Finland",
        },
        {
          id: "uk",
          name: "United Kingdom",
        },
      ],
    };
  },
  methods: {},
  computed: {
    ...mapGetters({
      stockProducts: "stockProducts/stockProductsGlobalOverview",
    }),
    stockProductsFiltered() {
      if (this.filterCountryId) {
        return this.stockProducts.filter(
          (stockProduct) => stockProduct.country.code === this.filterCountryId
        );
      } else {
        return this.stockProducts;
      }
    },
  },

  async created() {
    this.isLoading = true;
    await this.$store.dispatch("stockProducts/getStockProductsGlobalOverview");
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
